import { render, staticRenderFns } from "./artistList.vue?vue&type=template&id=5a9b9b48"
import script from "./artistList.vue?vue&type=script&lang=js"
export * from "./artistList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports